import Storages from '~utils/storages';

export default function useProfile() {
  const profile = Storages.getProfile();

  return {
    profile,
  };
}
